<form [formGroup]="form" (ngSubmit)="save()">
    <mat-spinner *ngIf="loading"></mat-spinner>
    <div *ngIf="!loading" class="edit-actions">
        <mat-spinner *ngIf="loadingAction" [diameter]="20"></mat-spinner>
        <button *ngIf="!loadingAction" type="button" matTooltip="Cancelar" (click)="cancel()" mat-icon-button class="card-inline">
      <mat-icon>clear</mat-icon>
    </button>
        <button *ngIf="!loadingAction" matTooltip="Guardar" mat-icon-button class="card-inline">
      <mat-icon>done</mat-icon>
    </button>
    </div>
    <h1>Configuracion</h1>
    <mat-divider></mat-divider>
    <div class="card-base  margin-botton-medium">
        <div class="card-content-wizard">
            <div class="card-container mat-elevation-z1">
                <div class="card-content">
                    <mat-form-field class="margin-right-small margin-top-xx">
                        <input matInput placeholder="Nombre" formControlName="Name" required>
                        <mat-error *ngIf="f.Name.errors  && f.Name.errors.required">
                            Ingrese el nombre de la plantilla
                        </mat-error>
                    </mat-form-field>

                    <mat-form-field class="margin-right-small margin-top-xx">
                        <mat-select placeholder="Prácticas región" formControlName="PracticeRegions" multiple>
                            <mat-select-trigger>
                                {{f.PracticeRegions.value?.length > 0 ? f.PracticeRegions.value[0].Name : ''}}
                                <span *ngIf="f.PracticeRegions.value?.length > 1" class="additional-selection">
                                            (+{{f.PracticeRegions.value.length - 1}} {{f.PracticeRegions.value?.length === 2 ? 'otra' : 'otras'}})
                                          </span>
                            </mat-select-trigger>
                            <mat-option *ngFor="let practiceRegionFilter of practiceRegionFilters" [value]="practiceRegionFilter">
                                {{practiceRegionFilter.Name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-form-field class="margin-right-small margin-top-xx">
                        <mat-select placeholder="Médico" formControlName="Physicians" multiple>
                            <mat-select-trigger>
                                {{f.Physicians.value?.length > 0 ? f.Physicians.value[0].Name : ''}}
                                <span *ngIf="f.Physicians.value?.length > 1" class="additional-selection">
                                            (+{{f.Physicians.value.length - 1}} {{f.Physicians.value?.length === 2 ? 'otra' : 'otros'}})
                                          </span>
                            </mat-select-trigger>
                            <mat-option *ngFor="let physicianFilter of physicianFilters" [value]="physicianFilter">
                                {{physicianFilter.Name}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <mat-divider></mat-divider>


                    <div *ngIf="!environmentPreset.tinyEditor && !this.txControlEnabled" class="margin-top-medium margin-botton-medium">
                        <angular-editor id="editor1" formControlName="Text" [config]="editorConfig"></angular-editor>
                    </div>
                    <div *ngIf="environmentPreset.tinyEditor && !this.txControlEnabled" class="margin-top-medium margin-botton-medium">
                        <textarea formControlName="Text" id="tiny"></textarea>
                    </div>


                    <app-txt-control-editior *ngIf="this.txControlEnabled && !loading" [text]="text" #txtControlEditor></app-txt-control-editior>


                </div>
            </div>
        </div>
    </div>

</form>